export default __webpack_public_path__ + "media/images/brands/burleigh-3bfe7a26e81b0f728ef01af4382782c9.png";